<div class="template__editor-header">
  <h3 mat-dialog-title class="template__editor-header-title">Template Data List</h3>
  <div class="template__editor-header-form">
    <mat-form-field>
      <input matInput [formControl]="templateName" placeholder="Name your template" class="template__editor-header-form-template-name" required>
      <mat-error *ngIf="templateName.hasError('required')">
        Template Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <button mat-raised-button class="template__editor-header-form-btn-duplicate" color="primary">
      <mat-icon>file_copy_outline</mat-icon>
      Duplicate
    </button>
  </div>
</div>
<div mat-dialog-content class="template__editor-content">
  <cdk-virtual-scroll-viewport itemSize="90" class="template__editor-content-viewport">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="template__editor-content-viewport-tree">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding matTreeNodePaddingIndent="20" class="template__editor-content-viewport-tree-node">
          <p class="template__editor-content-viewport-tree-node-name"> {{node.item}} </p>
          <div class="template__editor-content-viewport-tree-node-container">
            <mat-slide-toggle 
              color="primary"
              [checked]="node.selected"
              (change)="toggleNode(node)">
            </mat-slide-toggle>
            <mat-form-field>
              <input matInput [(ngModel)]="node.alias" placeholder="alias" class="template__editor-content-viewport-tree-node-alias">
            </mat-form-field>
          </div>
        </mat-tree-node>
     
        <mat-tree-node *matTreeNodeDef="let node; when: isObjectWithChild" matTreeNodePadding matTreeNodePaddingIndent="20" class="template__editor-content-viewport-tree-node">
          <p class="template__editor-content-viewport-tree-node-name"> {{node.item}} </p>
          <div class="template__editor-content-viewport-tree-node-container">
            <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.item">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          </div>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: isArrayWithChild" matTreeNodePadding matTreeNodePaddingIndent="20" class="template__editor-content-viewport-tree-node">
          <p class="template__editor-content-viewport-tree-node-name"> {{node.item}} - display: </p>
          <div class="template__editor-content-viewport-tree-node-array-container">
            <mat-slide-toggle 
              color="primary"
              [checked]="node.selected"
              (change)="toggleNode(node)">
            </mat-slide-toggle>
            <mat-select [disabled]="!node.selected" (selectionChange)="setMaxItems($event, node)" [placeholder]="10">
              <mat-option *ngFor='let number of 25 | numberPipe' [value]="number">
                {{number}}
              </mat-option>
            </mat-select>
            <p class="template__editor-content-viewport-tree-node-max">(max 25 items)</p>
            <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.item">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
          </div>
        </mat-tree-node>
      </mat-tree>
    </cdk-virtual-scroll-viewport>
</div>
<div mat-dialog-actions class="template__editor-footer">
  <button mat-raised-button class="template__editor-footer-btn-cancel" color="accent" (click)="onCancelClick()">Cancel</button>
  <button mat-raised-button class="template__editor-footer-btn-default" color="accent" (click)="onSetAsDefaultClick()">Set As Default</button>
  <button mat-raised-button cdkFocusInitial class="template__editor-footer-btn-save" color="primary" (click)="onSaveClick()" [disabled]="templateName.invalid">Save</button>
</div>
